<shared-spinner />
<router-outlet />
